/* unplugin-vue-components disabled */import { render } from "./feed-item.vue?vue&type=template&id=63c35eeb&scoped=true"
import script from "./feed-item.vue?vue&type=script&lang=js"
export * from "./feed-item.vue?vue&type=script&lang=js"

import "./feed-item.vue?vue&type=style&index=0&id=63c35eeb&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c35eeb"],['__file',"src/pages/pulse/feed/feed-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63c35eeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63c35eeb', __exports__)) {
    api.reload('63c35eeb', __exports__)
  }
  
  module.hot.accept("./feed-item.vue?vue&type=template&id=63c35eeb&scoped=true", () => {
    api.rerender('63c35eeb', render)
  })

}


export default __exports__